import { PaginationFilterRequest } from "./core.model";

export enum ClubTagTypeEnum {
  Vibe = 1,
  Distance = 2,
  UserBase = 3,
  AfterRun = 4,
}

export const ClubTagTypeList = [
  { value: ClubTagTypeEnum.Vibe, label: "Vibe" },
  { value: ClubTagTypeEnum.Distance, label: "Distance" },
  { value: ClubTagTypeEnum.UserBase, label: "User base" },
  { value: ClubTagTypeEnum.AfterRun, label: "After run" },
];

export const clubTagTypeLabel = (type: ClubTagTypeEnum) =>
  ClubTagTypeList.find(t => t.value === type)?.label ?? `${type}`;

export interface ClubTag {
  id: number;
  type: ClubTagTypeEnum;
  /** Stable lowercase kebab-case identifier; the app may key icons off it, so avoid renaming. */
  key: string;
  title: string;
}

export interface UpsertClubTag {
  id?: number;
  type?: ClubTagTypeEnum;
  key?: string;
  title?: string;
}

export class ClubTagPaginationFilterRequest extends PaginationFilterRequest {
  type?: ClubTagTypeEnum;
}
